import React, { Component } from 'react';
import moment from 'moment';
import Constants from '../../../../constants/Constants';
import { dateTimeRangeRounding } from '../../utils/ReportDateTimeUtils';

const filterSpacingStyle = { width: '20%', marginRight: '2rem' };

class DateTimeRangeRounding extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(newProps) {
    var newState = this.buildState(newProps);
    if (newState) {
      this.handleStatePropagation(newState);
    }
  }

  buildState = (props) => {
    let newStartString = props.query[this.props.settings.key[0]];
    let newEndString = props.query[this.props.settings.key[1]];

    if (
      (!newStartString && !newEndString) ||
      (this.state &&
        this.state.dateFrom &&
        this.state.dateFrom.isSame(newStartString) &&
        this.state.dateTo &&
        this.state.dateTo.isSame(newEndString))
    ) {
      return null;
    }

    return dateTimeRangeRounding(newStartString, newEndString, this.props.settings.options);
  };

  isQueryDifferentFromState = () => {
    return (
      !this.state ||
      this.state.dateFrom.format() != this.props.query[this.props.settings.key[0]] ||
      this.state.dateTo.format() != this.props.query[this.props.settings.key[1]]
    );
  };

  handleStatePropagation = (newRange) => {
    this.setState({ ...this.state, ...newRange }, () => this.handleNotification());
  };

  handleNotification = () => {
    if (this.isQueryDifferentFromState()) {
      this.props.onChanged(
        {
          [this.props.settings.key[0]]: this.state.dateFrom.format(),
          [this.props.settings.key[1]]: this.state.dateTo.format(),
          [this.props.settings.key[2]]: this.state.optionValue,
        },
        this.props.settings
      );
    }
  };

  render() {
    return this.state.reductionSpanHumanString ? (
      <p className="u-italic" style={{ color: Constants.COLORS.WARNING }}>
        Will display one data point for each period of {this.state.reductionSpanHumanString} of raw
        data, from {this.state.dateFrom.format('YYYY-MM-DD HH:mm')} to{' '}
        {this.state.dateTo.format('YYYY-MM-DD HH:mm')}
      </p>
    ) : null;
  }
}

export default DateTimeRangeRounding;
